import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, Router, ActivatedRoute, RouterStateSnapshot } from "@angular/router";
import { Meta, Title } from "@angular/platform-browser";
import { environment } from "src/environments/environment";
import { UserService } from "../services/user.service";

// meta.resolver.ts
@Injectable({ providedIn: 'root' })
export class MetaResolver implements Resolve<any> {
    path = '/'

  constructor(
    private titleService: Title,
    private userService:UserService,
    ) {}

  resolve(route: ActivatedRouteSnapshot,state: RouterStateSnapshot) {
    this.path = state.url;
    this.addMetaService()
  }

  addMetaService(){
    const title = "Gujarat Tiles Info."
    const desc = "Gujarat Tiles Info (GTI), founded in 2012 and headquartered in Morbi, Gujarat, is a leading ceramic industry directory and B2B portal dedicated to India's thriving ceramic sector. "
    const keywords = "Gujarat Tiles Info, ceramic tiles directory, Morbi tiles manufacturers, tiles dealers Gujarat, sanitaryware suppliers, vitrified tiles exporters, ceramic industry India, raw material suppliers, tile transporters, tile exhibitions India, digital wall tiles, floor tiles Gujarat, ceramic business directory, tiles B2B portal, Gujarat tile companies"

    const logo = 'https://gujarattilesinfo.com/assets/img/logo-200x200.png'
    this.titleService.setTitle(title)
    this.userService.addMetaTag('name','title','content',title)
    this.userService.addMetaTag('name','description','content',desc)
    this.userService.addMetaTag('name','keywords','content',keywords)
    this.userService.addMetaTag('property','og:title','content',title)
    this.userService.addMetaTag('property','og:description','content',desc)
    this.userService.addMetaTag('property','og:url','content',environment.BASE_URL+this.path)
    this.userService.addMetaTag('property','og:image','content',logo)
    this.userService.addMetaTag('property','og:image:width','content','500')
    this.userService.addMetaTag('property','og:image:height','content','500')
    this.userService.addMetaTag('property','og:type','content','website')
    this.userService.addMetaTag('name','twitter:card','content','summary_large_image')
    this.userService.addMetaTag('name','twitter:title','content',title)
    this.userService.addMetaTag('name','twitter:description','content',desc)
    this.userService.addMetaTag('name','twitter:image','content',logo)
}
}
